import { useContext } from 'react';
import { ReportErrorContext } from './report-error-context';

export const useReportError = () => useContext(ReportErrorContext);
